export default {"src":"/_next/static/media/risk-prioritization.1c0c8074.svg","height":212,"width":212,"blurWidth":0,"blurHeight":0};